import {
  KuposCheckbox,
  KuposDatePicker,
  KuposErrorSuccessModal,
  KuposInput,
  KuposModal,
  KuposSelectBox,
  SvgHome,
} from '../../../common';
import React, { useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';

const CancellationInputs = ({
  t,
  activeTab,
  loadTicketDetails,
  history,
  is_change_ticket,
  cancel_mode,
  travels,
  apiCall,
  actions,
}) => {
  const [cancelPrintTicketDate, setCancelPrintTicketDate] = useState('');
  const [cancelPrintTicketPNRError, setCancelPrintTicketPNRError] = useState('');
  const [cancelPrintTicketPNR, setCancelPrintTicketPNR] = useState('');
  const [cancelPrintTicketEmailError, setCancelPrintTicketEmailError] = useState('');
  const [cancelPrintTicketEmail, setCancelPrintTicketEmail] = useState('');
  const [cancelPrintTicketPhoneError, setCancelPrintTicketPhoneError] = useState('');
  const [cancelPrintTicketPhone, setCancelPrintTicketPhone] = useState('');
  const [cancelPrintTicketDateError, setCancelPrintTicketDateError] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(null);
  const [modalSuccess, setModalSuccess] = useState(null);
  const [modalBodyText, setModalBodyText] = useState(null);
  const [capsuleMenuAcktiveTab, setCapsuleMenuAcktiveTab] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(travels[0]);
  const [
    acceptToTermsConditionsCancelationPolicies,
    setAcceptToTermsConditionsCancelationPolicies,
  ] = useState(false);
  const [pnrPopup, setPnrPopup] = useState(false);

  const onCancelPrintTicketChange = (text, inp) => {
    if (inp == 'pnr') {
      setCancelPrintTicketPNRError(null);
      setCancelPrintTicketPNR(text.replace(/ /g, ''));
    } else if (inp == 'email') {
      setCancelPrintTicketEmailError(null);
      setCancelPrintTicketEmail(text);
    } else if (inp == 'phone') {
      setCancelPrintTicketPhoneError(null);
      setCancelPrintTicketPhone(text);
    } else if (inp == 'operator') {
      setSelectedOperator(text);
    }
  };

  sessionStorage.setItem('is_change_ticket', is_change_ticket ? true : false);

  const onCancelPrintTicketBlur = (text, inp) => {
    if (!text) {
      if (inp == 'email') {
        setCancelPrintTicketEmailError({
          message: 'VALIDATIONS.VALID_EMAIL',
        });
      } else if (inp == 'pnr') {
        setCancelPrintTicketPNRError({
          message: 'VALIDATIONS.VALID_RESERVATION',
        });
      } else if (inp == 'phone' && cancel_mode == 'offline') {
        // if (!CommonService.isEMailValid(text)) {
        setCancelPrintTicketPhoneError({
          message: 'PASSENGER_DETAILS.INSERT_MOT_PHONE_ERROR',
        });
        // }
      }
    } else if (inp == 'email' && cancel_mode == 'online') {
      if (!CommonService.isEMailValid(text)) {
        setCancelPrintTicketEmailError({
          message: 'VALIDATIONS.VALID_EMAIL',
        });
      }
    }
  };

  const onCancelPrintTicketSubmit = () => {
    let errorCount = 0;
    if (!cancelPrintTicketPNR) {
      setCancelPrintTicketPNRError({
        message: 'VALIDATIONS.VALID_RESERVATION',
      });
      errorCount++;
    }
    if (!cancelPrintTicketEmail && cancel_mode === 'online') {
      setCancelPrintTicketEmailError({
        message: 'VALIDATIONS.VALID_EMAIL',
      });
      errorCount++;
    } else if (!CommonService.isEMailValid(cancelPrintTicketEmail) && cancel_mode === 'online') {
      setCancelPrintTicketEmailError({
        message: 'VALIDATIONS.VALID_EMAIL',
      });
      errorCount++;
    }

    if (!cancelPrintTicketPhone && cancel_mode === 'offline') {
      setCancelPrintTicketPhoneError({
        message: 'PASSENGER_DETAILS.INSERT_MOT_PHONE_ERROR',
      });
      errorCount++;
    }

    if (!cancelPrintTicketDate && activeTab === 1) {
      // if (!cancelPrintTicketDate) {
      setCancelPrintTicketDateError({
        message: 'VALIDATIONS.VALID_DATE',
      });
      errorCount++;
    }
    if (errorCount > 0) {
      return;
    }
    let path = 'travel_date=' + cancelPrintTicketDate;
    path += '&contact_info=' + cancelPrintTicketEmail;
    path += '&is_mobile_app=' + true;
    path += '&do_cancel=' + true;

    if (is_change_ticket) {
      path += '&is_change_ticket=' + true;
    }
    let canCancelTicketData = {
      pnr_number: cancelPrintTicketPNR,
      travel_date: DateService.changeDateFormat(cancelPrintTicketDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
      api_travel_id: selectedOperator && selectedOperator.id,
      phone_number: cancelPrintTicketPhone,
    };

    let canChangeTicketData = {
      pnr_number: cancelPrintTicketPNR,
      travel_date: DateService.changeDateFormat(cancelPrintTicketDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
      api_travel_id: selectedOperator && selectedOperator.id,
      phone_number: cancelPrintTicketPhone,
      is_change_ticket: true,
    };

    let canCancelData = is_change_ticket ? canChangeTicketData : canCancelTicketData;
    // if (activeTab == 1) {
    //   path += '&do_cancel=' + true;

    // }

    onCancelSubmit(path, cancelPrintTicketPNR, canCancelData);
  };

  const onCancelSubmit = (path, pnr, canCancelData) => {
    let pathObj = CommonService.queryToObject(path);
    // let paramData = { pnr_number: pnr, ...pathObj };
    let dataEnc = CommonService.createJwtFullAndEncrypt(canCancelData, '@pullman&ts' + '&cancel@');
    cancel_mode === 'offline'
      ? apiCall({
          url: ApiUrls.canCancelDirect(),
          method: 'POST',
          data: {
            token: dataEnc,
          },
        }).then(res => {
          if (
            res &&
            res.data &&
            res.data.data &&
            res.data.status == 200 &&
            res.data.data.code == 200
          ) {
            // alert('respnse issed');
            let ticketDetails = res.data.data.data;
            ticketDetails.seat_Details = {};
            let setDetails = {};

            for (let s of res.data.data.data.seat_details) {
              setDetails[s.seat_number] = {
                seat_number: s.seat_number,
                title: 'Mr',
                name: s.passenger_name,
                age: '',
                fare: s.ticket_fare,
                sex: 'M',
                is_primary: true,
                id_card_number: '',
                id_card_type: 3,
                id_card_issued_by: '',
                nationality: '1',
                piso_type: '1',
                cancel_status: 0,
                travel_operator_pnr: null,
              };
            }
            ticketDetails.seat_Details.seat_details = setDetails;
            sessionStorage.setItem('offlineCancel', true);
            sessionStorage.setItem('canCancelData', JSON.stringify(canCancelData));
            sessionStorage.setItem('ticketInfo', JSON.stringify(ticketDetails));
            actions.setTicketDetails(ticketDetails);
            history.push('/modify-ticket/cancel');
          } else {
            setShowSuccessModal(true);
            setModalSuccess(false);
            setModalBodyText(t('HOME.TICKET_CANCELLED'));
          }
        })
      : loadTicketDetails({
          url: ApiUrls.ticketDetails(pnr, path),
        }).then(
          res => {
            sessionStorage.setItem('offlineCancel', false);
            if ((res.body && res.body.pnr_number) || (res.result && res.result.pnr_number)) {
              if (capsuleMenuAcktiveTab == 0) {
                window.open(res.body.print_pdf_url, '_blank');
              } else {
                if (
                  (res.body &&
                    res.body.pnr_number &&
                    (res.body.status.toLowerCase() == 'cancelado' ||
                      res.body.status.toLowerCase() == 'cancelled')) ||
                  (res.result &&
                    res.result.pnr_number &&
                    (res.result.status.toLowerCase() == 'cancelado' ||
                      res.result.status.toLowerCase() == 'cancelled'))
                ) {
                  //   this.setState({
                  //     showSuccessModal: true,
                  //     modalSuccess: false,
                  //     modalBodyText: t('HOME.TICKET_CANCELLED'),
                  //   });
                  setShowSuccessModal(true);
                  setModalSuccess(false);
                  setModalBodyText(t('HOME.TICKET_CANCELLED'));
                } else {
                  history.push('/modify-ticket/cancel');
                }
              }
              sessionStorage.setItem('is_change_ticket', is_change_ticket ? true : false);
            } else {
              CommonService.removeLocal('ticketInfo');
              console.log('response', res);

              if (res && res.body && res.body.message === 'El número de reserva es inválido') {
                console.log('El número de reserva es inválido', res);

                setShowSuccessModal(true);
                setModalSuccess(false);
                setModalBodyText(t('CANCEL_TICKET.INVALID_PNR'));
                // this.setState({
                //   showSuccessModal: true,
                //   modalSuccess: false,
                //   modalBodyText: t('CANCEL_TICKET.INVALID_PNR'),
                // });
              } else {
                setShowSuccessModal(true);
                setModalSuccess(false);
                setModalBodyText(res.body ? res.body.message : res.error);
                // this.setState({
                //   showSuccessModal: true,
                //   modalSuccess: false,
                //   modalBodyText: res.body ? res.body.message : res.error,
                // });
              }
            }
          },
          err => {
            console.log('error data in cancel ticket -----', err);
            // this.setState({
            //   showSuccessModal: true,
            //   modalSuccess: false,
            //   modalBodyText: t('CANCEL_TICKET.INVALID_PNR_AT'),
            //   // modalBodyText: err.data ? err.data.message : err.statusText,
            // });
            setShowSuccessModal(true);
            setModalSuccess(false);
            setModalBodyText(t('CANCEL_TICKET.INVALID_PNR_AT'));
            // console.log('Result failure is', err);
          },
        );
  };

  const handlePnrPopup = () => {
    setPnrPopup(!pnrPopup);
  };
  return (
    <React.Fragment>
      <div className="home-selection-input-boxes">
        {cancel_mode == 'offline' ? (
          <div className="home-selection-input-box font10">
            <span className="label font13px bold-text margin-B5 d-inline-block">
              {t('CANCEL_TICKET.OPERATOR')}
            </span>
            <KuposSelectBox
              smallArrow={true}
              height={38}
              fontSize={14}
              noPaddingLeft={true}
              // error={this.state.bankForm.bank_nameError ? true : false}
              // errorMessage={
              //   this.state.bankForm.bank_nameError ? this.state.bankForm.bank_nameError.message : ''
              // }
              selectedOption={selectedOperator}
              options={travels}
              onChange={text => onCancelPrintTicketChange(text, 'operator')}
              styleClass={'common-kupos-select-box-cancellation'}
              t={t}
            />
          </div>
        ) : null}
        <div className="home-selection-input-box font10">
          <span className="label font13px bold-text margin-B5 d-inline-block">
            {t('CANCEL_TICKET.RESERVATION_NUMBER')}
          </span>
          <KuposInput
            placeholder={t('CANCEL_TICKET.RESERVATION_NUMBER_PLACEHOLDER')}
            type="text"
            // className="kupos-border"
            value={cancelPrintTicketPNR}
            onChange={text => onCancelPrintTicketChange(text, 'pnr')}
            onBlur={text => onCancelPrintTicketBlur(text, 'pnr')}
            error={cancelPrintTicketPNRError ? true : false}
            height={40}
            errorMessage={cancelPrintTicketPNRError ? t(cancelPrintTicketPNRError.message) : null}
          />
        </div>
        {cancel_mode == 'offline' ? (
          <div className="home-selection-input-box font10">
            <span className="label font13px bold-text margin-B5 d-inline-block">
              {t('CANCEL_TICKET.PHONE_NUMBER')}
            </span>

            <KuposInput
              placeholder={t('CANCEL_TICKET.PHONE_NUMBER')}
              type="text"
              // className="kupos-border"
              value={cancelPrintTicketPhone}
              onChange={text => onCancelPrintTicketChange(text, 'phone')}
              onBlur={text => onCancelPrintTicketBlur(text, 'phone')}
              error={cancelPrintTicketPhoneError ? true : false}
              errorMessage={
                cancelPrintTicketPhoneError ? t(cancelPrintTicketPhoneError.message) : null
              }
            />
          </div>
        ) : (
          <div className="home-selection-input-box font10">
            <span className="label font13px bold-text margin-B5 d-inline-block">
              {t('CANCEL_TICKET.EMAIL_ID')}
            </span>

            <KuposInput
              placeholder={t('CANCEL_TICKET.EMAIL_ID')}
              type="email"
              // className="kupos-border"
              value={cancelPrintTicketEmail}
              onChange={text => onCancelPrintTicketChange(text, 'email')}
              onBlur={text => onCancelPrintTicketBlur(text, 'email')}
              error={cancelPrintTicketEmailError ? true : false}
              errorMessage={
                cancelPrintTicketEmailError ? t(cancelPrintTicketEmailError.message) : null
              }
            />
          </div>
        )}
        <div className="home-selection-input-box font10">
          <span className="label font13px bold-text margin-B5 d-inline-block">
            {t('CANCEL_TICKET.TRAVEL_DATE')}
          </span>
          <KuposDatePicker
            placeholder={t('HOME.SELECT_DATE')}
            minDate={activeTab === 0 ? null : DateService.getTodayString()}
            selectedDate={cancelPrintTicketDate}
            onDateChange={data => {
              setCancelPrintTicketDate(data);
              setCancelPrintTicketDateError(null);
            }}
            error={cancelPrintTicketDateError ? true : false}
            errorMessage={cancelPrintTicketDateError ? t(cancelPrintTicketDateError.message) : null}
          />
        </div>
        <div className="home-selection-input-box font13px datebox mt-1">
          <button
            className="kupos-button home-selection-input-button font13px"
            onClick={onCancelPrintTicketSubmit}
          >
            {!is_change_ticket ? (
              <img
                className="icon-size"
                src="/images/icons/home/icon_search-white.png"
                alt={t('TRANSLATIONS.ICON_PRINT_TICKET')}
              />
            ) : null}
            <span className="ml-x-1">
              {t(is_change_ticket ? 'CHANGE_TICKET.TICKET_CODE_CONSULT' : 'HOME.SEARCH')}
            </span>
          </button>
        </div>
        <KuposErrorSuccessModal
          showModal={showSuccessModal}
          success={modalSuccess}
          onButtonClick={() => {
            setShowSuccessModal(false);
            setModalBodyText('');
          }}
          bodyText={modalBodyText}
          t={t}
        />
        <KuposModal
          ariaLabel="tnc-pnr-modal-outer"
          size={cancel_mode == 'offline' ? 'sm' : 'xl'}
          onHide={handlePnrPopup}
          showModal={pnrPopup}
        >
          <div className="tnc-pnr-modal">
            {pnrPopup && (
              <img
                src={
                  cancel_mode == 'offline'
                    ? '/images/pullman/Pullmanbus-WhereismyPNR-offline-new.png'
                    : '/images/pullman/home/cancellation-pnr.svg'
                }
                alt=""
              />
            )}
            <div className="close-button pointer" onClick={handlePnrPopup}>
              <SvgHome name="close" />
            </div>
          </div>
        </KuposModal>
      </div>
      <div>
        <div
          onClick={handlePnrPopup}
          className="home-selection-input-boxes-ref pointer font13px"
          style={{
            paddingTop: 5,
          }}
        >
          {t('CANCEL_TICKET.WHERE_TO_FIND_RESERVATION_NUMBER')}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CancellationInputs;



// WEBPACK FOOTER //
// ./src/features/home/HomeSearchBoxPB/RenderInputs/CancellationInputs.js